<template>
  <b-card
    class="card-variant"
    :class="{selected: selectedVariant === variant}"
    @click="selectValue(variant)"
  >
    {{getDisplayValue}}
  </b-card>
</template>

<script>
export default {
  name: 'CardLocationVariant',
  props: {
    variant: {
      type: Object,
      required: true
    },
    selectedVariant: {
      type: Object
    }
  },
  methods: {
    selectValue (value) {
      this.$emit('selected-variant', value)
    }
  },
  data () {
    return {

    }
  },
  computed: {
    getDisplayValue () {
      if (this.variant) {
        let variant = this.variant
        let addressParts = []
        if (variant.city) {
          addressParts.push(`г. ${variant.city}`)
        }
        if (variant.region) {
          addressParts.push(variant.region)
        }
        if (variant.settlement) {
          addressParts.push(variant.settlement)
        }
        if (variant.street) {
          addressParts.push(variant.street)
        }
        return addressParts.join(', ')
      }
    }
  }
}
</script>

<style scoped>
  .selected {
    background: green;
    color: white;
  }
  .card-variant {
    cursor:pointer;
    font-size: 18px;
  }
</style>


// WEBPACK FOOTER //
// src/components/CardLocationVariant.vue